import EDPReservationPolicies from 'components/Content/Happening/HappeningEDP/EDPReservationPolicies/EDPReservationPolicies';

export default EDPReservationPolicies;
